declare namespace Admin {
  export type Member = {
    memberCount: FirebaseFirestore.FieldValue | number;
  };
  export type Notification = {
    notificationCount: FirebaseFirestore.FieldValue | number;
  };
}

export default Admin;
